import { useMediaQuery, useTheme } from '@mui/material';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { ReactComponent as LogoSvg } from '../../assets/fs-logo-2022.svg';
import { Routes } from '../../constants';

export const Logo: FC = () => (
  <Link to={Routes.home}>
    <LogoSvgView />
  </Link>
);

export const LogoSvgView: FC = () => {
  const theme = useTheme();
  const isLargeWidth = useMediaQuery(theme.breakpoints.up('lg'));

  return (
    <LogoSvg style={{ width: isLargeWidth ? '208px' : '144px', marginLeft: theme.spacing(1.5) }} />
  );
};
